import React, { FC, ImgHTMLAttributes, useMemo } from "react";
import { imagePath } from "./util";

const ResolutionImg: FC<ImgHTMLAttributes<HTMLImageElement> & { pc: string; sp: string }> = ({ pc, sp, ...props }) => {
  const src = useMemo(() => imagePath(pc), []);
  const srcSet = useMemo(() => `${imagePath(pc)} 1x,${imagePath(sp)} 2x`, []);
  return <img {...props} src={src} srcSet={srcSet} />;
};
export default ResolutionImg;
